export const validate = (value) => {
  if (typeof value === 'string') { // Check if value is a string
    return value.trim().length !== 0;
  } else {
    return false; // Return false for non-string values
  }
};
export const isValidDate = (dateString) => {
  // Regular expression to match the format dd-mm-yyyy
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  return regex.test(dateString);
};

export const validatePassword = (password) => {
  // At least 8 characters
  const lengthRegex = /.{8,}/;

  // At least one special character
  const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;

  // At least one number
  const numberRegex = /\d/;

  // At least one uppercase letter
  const uppercaseRegex = /[A-Z]/;

  // At least one lowercase letter
  const lowercaseRegex = /[a-z]/;

  // Combine all the regex patterns
  // const passwordRegex = new RegExp(
  //   `^(?=.*${lengthRegex.source})(?=.*${specialCharRegex.source})(?=.*${numberRegex.source})(?=.*${uppercaseRegex.source})(?=.*${lowercaseRegex.source}).*$`
  // );

  // only 8 chars validate
  const passwordRegex = new RegExp(`^${lengthRegex.source}$`);


// console.log(passwordRegex.test(password));

  return passwordRegex.test(password);
};
export const validateEmail = (email, required = false) => {
  if (required) {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }
  else if (validate(email)) {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }
  return true
};

export const validatePhone = (phone, required = false) => {
  var regx = /^[6-9]\d{9}$/;
  if (required) {
    return regx.test(phone)
  }
  else if (validate(phone)) {
    return regx.test(phone)
  }
  return true
}

export function filterByValue(array, string) {
  return array.filter((item) =>
  Object.values(item).some((value) =>
    String(value).toUpperCase().includes(string.toUpperCase())
  )
)
}
export const formatDates = (inputDate) => {
  if (inputDate) {
    const parts = inputDate.split("/"); // Split the date string by '-'

    // Create a new Date object using the parts
    const date = new Date(parts[0], parts[1] - 1, parts[2]);
    date.setDate(date.getDate() + 1);
    // Extract the month, day, and year from the Date object
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    // Format the date in MM/DD/YYYY format
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  }
};
export const formatWord = (str: string) => {
  if (typeof str !== 'string') {
    return str;
  }
  return str
    .replace(/_/g, " ") // Replace underscores with spaces
    .split(" ") // Split by space to capitalize each word
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter
    .join(" "); // Join the words back together
};
